/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessApprovalStateDto } from '../../models/kyc-process-approval-state-dto';

export interface GetApprovalState$Params {
  processId: string;
}

export function getApprovalState(http: HttpClient, rootUrl: string, params: GetApprovalState$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessApprovalStateDto>> {
  const rb = new RequestBuilder(rootUrl, getApprovalState.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessApprovalStateDto>;
    })
  );
}

getApprovalState.PATH = '/kyc/processes/{processId}/approvals/state';
